import React, {useState} from 'react';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import MainModal from 'shared/ui/Modal/MainModal';
import {buildFileUrl} from 'features/http/lib/fileUrl';
import {isTranslate} from 'shared/lib/lang';

import styles from './HttpIncidentScreenshot.module.scss';

interface IHttpIncidentScreenshotProps {
    file?: string | null,
}

const HttpIncidentScreenshot: React.FC<IHttpIncidentScreenshotProps> = ({file}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isBroken, setIsBroken] = useState(false);
    const url = buildFileUrl(file);

    if (!url || isBroken) {
        return null;
    }

    return (
        <div className={styles.container}>
            <div className={styles.title}>{t`Скриншот страницы ошибки`}</div>
            <button
                type="button"
                className={cn(styles.preview, isTranslate() && styles.enPreview)}
                onClick={() => setIsOpen(true)}
                title={t`Открыть скриншот в полный размер`}
            >
                <img
                    className={styles.previewImage}
                    src={url}
                    alt={t`Скриншот страницы ошибки`}
                    onError={() => setIsBroken(true)}
                />
                <span className={styles.previewHint}>{t`Открыть в полный размер`}</span>
            </button>

            <MainModal
                open={isOpen}
                handleClose={() => setIsOpen(false)}
                header={t`Скриншот страницы ошибки`}
                size="lg"
            >
                <div className={styles.fullSize}>
                    <img
                        className={styles.fullSizeImage}
                        src={url}
                        alt={t`Скриншот страницы ошибки`}
                    />
                </div>
            </MainModal>
        </div>
    );
};

export default HttpIncidentScreenshot;
